// Punto de entrada principal de SubiGol
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastProvider } from './components/ui/Toast'
import useThemeStore from './store/useThemeStore'
import AppRouter from './router/AppRouter'
import './index.css'


// Configuración del cliente de TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 segundos de caché fresco
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Inicializar el tema al cargar la aplicación
useThemeStore.getState().initTheme()


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AppRouter />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
